module.exports = __webpack_public_path__ + "img/1802.12cd43ab.jpg";